<template>
    <div class="customer-files">
        <DCard>
            <DRow>
                <DCol>
                    <DTable
                        :items="customerFiles"
                        :fields="fields"
                    >
                        <template #created_at="{item}">
                            <td>
                                {{ setDateFormat(item.created_at) }}
                            </td>
                        </template>
                        <template #actions="{item}">
                            <td>
                                <div style="display: flex; grid-gap: 10px;">
                                    <DButton
                                        icon="download"
                                        mini
                                        @click="item.nitro_file === true ? downloadFile(item.id) : downloadWeSellFile(item)"
                                    />
                                    <DButton
                                        v-if="(userPermissions.includes('customer.comment') || userPermissions.includes('customer.edit')) && item.nitro_file"
                                        icon="trash-can-outline"
                                        color="danger"
                                        :disabled="isInLoadingState"
                                        mini
                                        @click="deleteFile(item.id)"
                                    />
                                    <DButton
                                        v-if="(userPermissions.includes('customer.comment') || userPermissions.includes('customer.edit')) && item.nitro_file"
                                        icon="pencil"
                                        mini
                                        @click="editFile(item.id)"
                                    />
                                </div>
                            </td>
                        </template>
                    </DTable>
                </DCol>
            </DRow>
        </DCard>

        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
            <DFab
                v-if="userPermissions.includes('customer.comment')"
                icon="plus"
                :label="__('customers.customer-files.create')"
                @click="$inertia.get($route('customers.customers.customer-files.create', {customer: customer.id}))"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('customers.customer-files.delete_confirmation.title')"
            :message="__('customers.customer-files.delete_confirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'

export default {
    name: 'CustomerFileIndex',
    components: { CreateCloudPitCustomerModal, SSOFab },
    layout: [App, CustomerBase],
    props: {
        customerFiles: {
            type: Array,
            default: () => { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'description', label: this.__('customers.customer-files.description') },
                { key: 'original_name', label: this.__('customers.customer-files.original_name') },
                { key: 'created_at', label: this.__('customers.customer-files.created_at') },
                { key: 'user_name', label: this.__('customers.customer-files.username') },
                { key: 'actions', label: '' }
            ],
            showConfirmationModal: false,
            deleteCallBack: () => {},
            showCreateCloudpitCustomerModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        downloadFile (id) {
            const link = document.createElement('a')
            link.href = this.$route('customers.customers.customer-files.download', {
                customer: this.customer.id,
                customerFile: id
            })
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        downloadWeSellFile (file) {
            window.open(file.url, '_blank')
        },
        deleteFile (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(
                    this.$route('customers.customers.customer-files.destroy', {
                        customer: this.customer.id,
                        customer_file: id
                    }),
                    {
                        preserveScroll: true
                    }
                )
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        closeModal () {
            this.showConfirmationModal = false
            this.deleteCallBack = () => {}
        },
        editFile (id) {
            return this.$inertia.get(
                this.$route('customers.customers.customer-files.edit', { customer: this.customer.id, customer_file: id })
            )
        }
    }
}
</script>
